<template>
  <div class="cascaderArea">
    <el-cascader
        ref="cascaderRef"
        :options="optionsTree"
        :props="cascaderProps"
        v-model="innerValue"
        :clearable="clearable"
        :placeholder="placeholder"
        style="width: 300px"
        @change="handleChange"
    ></el-cascader>
  </div>
</template>

<script>
import { userList } from '@/api/dilivery/user'
import { ch_en_role } from "@/utils/ch_en_trans";

export default {
  name: 'Cascader',
  props: {
    multiple: { type: Boolean, default: true },
    value: { type: Array, default: () => [] },
    clearable: { type: Boolean, default: true },
    placeholder: { type: String, default: '请选择' }
  },
  data() {
    return {
      innerValue: [],
      optionsTree: [],
      echoToken: 0,          // 回显数据就绪后 +1，重挂载让 el-cascader 原生渲染选中
      loadedRoleMap: {}      // 缓存已请求过的角色人员，避免重复请求
    }
  },
  async created() {
    this.innerValue = this.cloneValue(this.value)
    this.buildBaseRoleOptions()
    await this.loadEchoRoles()
  },
  watch: {
    value(newVal) {
      if (!this.sameValue(newVal, this.innerValue)) {
        this.innerValue = this.cloneValue(newVal)
      }
    }
  },
  computed: {
    echoKey() {
      return `cascader-${this.echoToken}`
    },
    cascaderProps() {
      return {
        multiple: this.multiple,
        lazy: true,
        lazyLoad: this.lazyLoadHandler
      }
    }
  },
  methods: {
    /** 构建一级角色节点（不请求人员） */
    buildBaseRoleOptions() {
      if (!Array.isArray(ch_en_role)) { this.optionsTree = []; return }
      this.optionsTree = ch_en_role.map(role => ({
        value: role.en,
        label: role.ch,
        leaf: false,
        children: []
      }))
    },

    /** 从回显值中提取所有角色 code */
    extractRoleCodes(val) {
      const codes = []
      const walk = (item) => {
        if (Array.isArray(item)) {
          if (typeof item[0] === 'string') codes.push(item[0])
          else item.forEach(walk)
        }
      }
      walk(val)
      return [...new Set(codes)]
    },

    /** 首次请求回显选中的角色人员，并填充到对应节点 */
    async loadEchoRoles() {
      if (!this.innerValue?.length) return
      const roleCodes = this.extractRoleCodes(this.innerValue)
      await Promise.all(roleCodes.map(async (code) => {
        if (this.loadedRoleMap[code]) return
        const children = await this.fetchChildrenByRole(code)
        this.loadedRoleMap[code] = children
        const node = this.optionsTree.find(o => o.value === code)
        if (node) node.children = children
      }))
    },

    /** el-cascader 懒加载回调：展开角色/回显补齐节点时触发 */
    async lazyLoadHandler(node, resolve) {
      if (node.level === 1) {
        const roleCode = node.value
        // 命中缓存（含首次回显已加载的）直接返回
        if (this.loadedRoleMap[roleCode]) {
          return resolve(this.loadedRoleMap[roleCode])
        }
        const children = await this.fetchChildrenByRole(roleCode)
        this.loadedRoleMap[roleCode] = children
        resolve(children)
      } else {
        resolve([])
      }
    },

    async fetchChildrenByRole(roleCode) {
      try {
        const res = await this.getUserByRole(roleCode)
        const records = res?.data?.records || []
        return records.map(item => ({
          value: item.uuid,
          label: item.name,
          leaf: true
        }))
      } catch (err) {
        console.warn(`角色【${roleCode}】人员加载失败`, err)
        return []
      }
    },

    getUserByRole(role) {
      return userList(role, { 'page.current': 1, 'page.size': 500 }, {})
    },

    cloneValue(val) {
      return Array.isArray(val) ? _.cloneDeep(val) : []
    },

    sameValue(a, b) {
      return JSON.stringify(a) === JSON.stringify(b)
    },

    handleChange(val) {
      this.innerValue = val
      this.$emit('input', val)
      this.$emit('getSelectedOptions', val)
    }
  }
}
</script>
